import { ApplicationRole } from './ApplicationRole';
import { BlockModel } from './BlockModel';
import { CompanyModel } from './CompanyModel';

export class RegisteredUserModel {
    
    User_Code: number = 0;
    User_Name: string = '';
    CAI: string = '';
    LogonId: string = '';
    Email: string = '';
    Is_Partner: boolean = false;
    Company: CompanyModel = new CompanyModel();
    Block: BlockModel = new BlockModel();
    ApplicationRoles: ApplicationRole[] = [];
    Roles: string = '';
    IsRFCAdmin: boolean = false;
    Departments: number[] = [];
    SubDepartments: number[] = [];
    JobTitle: string = '';
    CTN: string = '';
    Active: boolean = true;
    Status: string = 'Active';
    Created_By: number = 0;
    CompanyName: string = '';
    BlockName: string = '';
    // Company_Code: number;    
    // Company_Name : string;
    // Company_Active : boolean;
    // Block_Code: number;    
    // Block_Name : string;
} 